<mainadminlayout class="app mat-typography" class="screenable"
  [dir]="options.dir"
  [ngClass]="{'app-dark': options.dark, 'boxed': options.boxed, 'collapsed-sidebar': options.collapsed, 'side-panel-opened': sidePanelOpened, 'side-panel-closed': !sidePanelOpened }">
  <ngx-loading-bar color="#009688"></ngx-loading-bar>
  <app-header (toggleSidenav)="sidemenu.toggle()" (toggleNotificationSidenav)="notifications.toggle()"></app-header>
  <mat-sidenav-container class="app-inner">
    <mat-sidenav #sidemenu class="sidebar-panel" id="sidebar-panel" [mode]="isOver() ? 'over' : 'side'"
      [opened]="!isOver()" (openedStart)="sidePanelOpened = true" (closedStart)="sidePanelOpened = false"
      (mouseover)="menuMouseOver()" (mouseout)="menuMouseOut()" [perfectScrollbar]="config" [disabled]="isScreenSmall">
      <app-menu (click)="updatePS()" [direction]="options.dir"></app-menu>
    </mat-sidenav>
    <mat-sidenav #notifications position="end" class="chat-panel" mode="over" opened="false">
      <app-notification></app-notification>
    </mat-sidenav>
    <div [perfectScrollbar]="config" [disabled]="isScreenSmall">
      <router-outlet *ngIf="this.controllerService.userinfo.agent != undefined && this.controllerService.userinfo.agent != null && this.controllerService.userinfo.agent == true"></router-outlet>
      <mat-tab-group *ngIf="this.controllerService.userinfo.agent == undefined || this.controllerService.userinfo.agent == null || this.controllerService.userinfo.agent == false" [selectedIndex]="selectedTab" animationDuration="0ms"
        (selectedTabChange)="tabChanged($event)">
        <mat-tab *ngFor="let tab of tabs ; let index = index">
          <ng-template mat-tab-label>
            <mat-icon class="example-tab-icon">{{tab.icon}}</mat-icon>{{ tab.title }}
            <i class="material-icons" (click)="removeTab(index)">close</i>
          </ng-template>
          <app-tab-content [tab]="tab"></app-tab-content>
        </mat-tab>
      </mat-tab-group>
    </div>
  </mat-sidenav-container>
</mainadminlayout>


<!-- <mainadminlayout [class.isPrinting]="printService.isPrinting" class="app mat-typography" class="screenable"
  [dir]="options.dir"
  [ngClass]="{'app-dark': options.dark, 'boxed': options.boxed, 'collapsed-sidebar': options.collapsed, 'side-panel-opened': sidePanelOpened, 'side-panel-closed': !sidePanelOpened }">
  <ngx-loading-bar color="#009688"></ngx-loading-bar>
  <app-header (toggleSidenav)="sidemenu.toggle()" (toggleNotificationSidenav)="notifications.toggle()"></app-header>
  <mat-sidenav-container [class.isPrinting]="printService.isPrinting" class="app-inner">
    <mat-sidenav #sidemenu class="sidebar-panel" id="sidebar-panel" [mode]="isOver() ? 'over' : 'side'"
      [opened]="!isOver()" (openedStart)="sidePanelOpened = true" (closedStart)="sidePanelOpened = false"
      (mouseover)="menuMouseOver()" (mouseout)="menuMouseOut()" [perfectScrollbar]="config" [disabled]="isScreenSmall">
      <app-menu (click)="updatePS()" [direction]="options.dir"></app-menu>
    </mat-sidenav>
    <mat-sidenav #notifications position="end" class="chat-panel" mode="over" opened="false">
      <app-notification></app-notification>
    </mat-sidenav>
    <div [perfectScrollbar]="config" [disabled]="isScreenSmall">
      <router-outlet></router-outlet>
      <router-outlet name="print"></router-outlet>
    </div>
  </mat-sidenav-container> -->
  <!-- <router-outlet></router-outlet> -->
  <!-- Demo Purposes Only -->
  <!-- <app-options (messageEvent)="receiveOptions($event)"></app-options> -->
  <!-- /Demo Purposes Only -->
<!-- </mainadminlayout> -->


